import React, { useContext, useState, useEffect } from 'react'
import { Box, Text, Button, Menu, Layer, TextInput, FormField, CheckBox } from "grommet"
import axios from "axios";
import UserContext from '../../context/UserContext'
import EnvContext from '../../context/EnvContext'
import { Services } from 'grommet-icons'

import { gql, useQuery } from '@apollo/client';

import { CommandFormConfirmation, SendCommand } from '../health2/details/HealthStatusServiceHostActionsPanels'

import { useToasts } from 'react-toast-notifications'

import envConfig from '../../utils/envConfig'

const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

const DC_QUERY = gql`
query ($node: String) {
node(where: {name: {_eq: $node}}) {
    name
    datacenter {
      name
    }
  }
}
`

const NODES_BY_SERVICE_QUERY = gql`
query ($service: String, $envName: String) {
nodeByServiceGroupView(where: {environmentName: {_eq: $envName}, group: {_eq: $service}}) {
    nodeName
  }
}
`

function parseSelectedLambdaARN(nodedata) {
    let arns = nodedata.map(node => (node.data.arn))
    return arns
}

function parseSelectedLambdaFunction(nodedata) {
    let names = nodedata.map(node => (node.data.name))
    return names
}

function parseSelectedS3Bucket(nodedata) {
    let buckets = nodedata.map(node => (node.data.name))
    return buckets
}

function parseSelectedID(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.id)
    });
    return ids
}

function parseSelectedMarket(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.market)
    });
    return ids
}

function parseCompId(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.remoteCompId)
    });
    return ids
}

function parseFixType(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.type)
    });
    return ids
}

function parseNodeName(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.nodeName)
    });
    return ids
}



function parseSelectedUniqueID(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.uniqueId)
    });
    return ids
}

function parseSelectedUserID(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.user_id)
    });
    return ids
}

function parseSelectedIDReaper(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        const columns = node.data.columns.toString().slice(0, 18) + " ... ..."
        ids.push(" Keyspace: " + node.data.keyspace + " On Columns \n" + columns)
    });
    return ids
}

function parseSecondary(nodedata) {
    let pri = 0
    let sec = 0
    nodedata.forEach(node => {
        if (node.data.primary === "S") {
            sec += 1
        } else {
            pri += 1
        }
    });

    if (pri > 0 && sec > 0) {
        return 999
    }
    else if (sec > 0) {
        return true
    } else {
        return false
    }
}

function parseAppID(nodedata) {
    let apps = []
    nodedata.forEach(node => {
        apps.push(node.data.app)
    });
    return apps
}

function parseFromRegion(nodedata) {
    let regions = []
    nodedata.forEach(node => {
        const reg_name = node.data.route53.toString().slice(0, 4)
        if (reg_name === 'ane1') {
            regions.push('ap-northeast-1');
        } else if (reg_name === 'use1') {
            regions.push('us-east-1');
        } else if (reg_name === 'euw1') {
            regions.push('eu-west-1');
        }
    });
    return regions
}

function parseTitlebarRegion(nodedata) {
    let regions = []
    nodedata.forEach(node => {
        regions.push(node.data.region)
    });
    return regions
}

function parseSelectedEndpointGroups(nodedata) {
    let ids = []
    let names = []
    nodedata.forEach(node => {
        ids.push(node.data.endpointGroupARN)
        names.push(node.data.globalAcceleratorName + ":" + node.data.listenerPorts + ":" + node.data.endpointGroupRegion)
    });
    return [ids, names]
}

function parseSelectedRDSClusters(nodedata) {
    let ids = []
    nodedata.forEach(node => {
        ids.push([node.data.name, node.data.region, node.data.globalClusterName])
    });
    return ids
}

// Parse selected smoketest downtime configurations and fetch their ids
const parseSelectedSmoketestDowntimeConfig = (nodedata) => {
    let ids = []
    nodedata.forEach(node => {
        ids.push(node.data.id)
    });
    return ids
}

const AgDataTableActions = ({ agTable, tableName, nodeName, triageActionReason = '', s3PolicyExpiration = 20, s3ResyncHours = 12 }) => {

    const [isOpen, setIsOpen] = useState(false)
    const envSelected = useContext(EnvContext)
    //const fixMap = useFix()

    // For Commands
    const { addToast } = useToasts()
    const [confirmation, setConfirmation] = useState(false)
    const dcQuery = useQuery(DC_QUERY, {
        variables: { node: nodeName },
        skip: !nodeName ? true : false
    })

    const edgeServers = useQuery(NODES_BY_SERVICE_QUERY, {
        variables: { service: "edgeserver", envName: envSelected },
    })

    // For Command Variables
    const [appName, setAppName] = useState("")
    const [commandName, setCommandName] = useState("")
    const [message, setMessage] = useState("")
    const [param, setParam] = useState({})

    const [SubMenu, setSubMenu] = useState("")
    const [subMenuItems, setSubMenuItems] = useState([])

    // Authorization
    const token = useContext(UserContext)

    // Fix Reset UI
    const [show, setShow] = useState(true);
    const onOpen = () => setShow(true);
    const onClose = () => setShow(undefined);

    useEffect(() => {

        // Execute Actions
        const handleClickActions = () => {
            if (appName === "juno_up" && commandName === "account_reset" && param.account_id.split(",").length > 0) {

                param.account_id.split(",").forEach(acct => {

                    let newParam = param
                    newParam.account_id = acct

                    SendCommand(appName,
                        commandName,
                        "POST",
                        newParam,
                        {},
                        envSelected,
                        token,
                        addToast
                    )
                });
            }
            else if (appName === "aws") {
                if (commandName === "enable_lambda" || commandName === "disable_lambda") {
                    param.arn.split(",").forEach(lambda_arn => {
                        let newParam = param
                        param.arn = lambda_arn

                        SendCommand(appName,
                            commandName,
                            "POST",
                            newParam,
                            {},
                            envSelected,
                            token,
                            addToast
                        )
                    });
                } else if (
                    commandName === "enable_lambda_by_app" || commandName === "disable_lambda_by_app" ||
                    commandName === "enable_s3_by_app" || commandName === "disable_s3_by_app"
                ) {
                    param.application.split(",").forEach(tt_application => {
                        param.region.split(",").forEach(awsRegion => {
                            let newParam = param
                            newParam.application = tt_application
                            newParam.region = awsRegion
                            SendCommand(appName,
                                commandName,
                                "POST",
                                newParam,
                                {},
                                envSelected,
                                token,
                                addToast
                            )
                        });
                    });
                } else if (
                    commandName === "enable_s3" || commandName === "disable_s3" ||
                    commandName === "resync_s3_buckets"
                ) {
                    param.bucket.split(",").forEach(bucket_name => {
                        let newParam = param
                        param.bucket = bucket_name

                        SendCommand(appName,
                            commandName,
                            "POST",
                            newParam,
                            {},
                            envSelected,
                            token,
                            addToast
                        )
                    });
                } else {
                    SendCommand(appName,
                        commandName,
                        "POST",
                        param,
                        {},
                        envSelected,
                        token,
                        addToast
                    )
                }
            }



            else if (appName === "bouncer" && commandName === "reset_accounts" && param.secondary === 99) {
                addToast("Cannot have mix of Primary and Secondary Accounts for Bouncer Reset Accounts", {
                    appearance: "error",
                    autoDismiss: true,
                })
            }
            else if (appName === "reaper" && commandName === "repair") {
                addToast("Running selected Schedules Now.", {
                    appearance: "success",
                    autoDismiss: true,
                })
            }
            else {

                SendCommand(appName,
                    commandName,
                    "POST",
                    param,
                    {},
                    envSelected,
                    token,
                    addToast
                )

            }
        }

        if (confirmation) {
            handleClickActions()

            // reset all param after submit to prevent repeated submissions
            setConfirmation(false)
            setAppName("")
            setCommandName("")
            setParam({})

        }
    }, [confirmation, addToast, appName, commandName, envSelected, param, token])

    if (!token.scopes.includes("triage/x") && !token.scopes.includes("triage/ad")) {
        return <Box />
    }

    const handleClickBouncer = () => {
        if ((parseSelectedID(agTable.current.api.getSelectedNodes()).length) > 20) {
            addToast("Maximum 20 Accounts at a Time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("bouncer")
            setCommandName("reset_accounts")
            setMessage("Are you Sure you want to Reset the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Bouncer Account(s) \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
            setParam({
                target: nodeName,
                account_ids: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
                secondary: parseSecondary(agTable.current.api.getSelectedNodes()),
                include_hierachy: true,
                reason: triageActionReason
            })
        }
    }

    const handleClickConnectionDisable = () => {
        setIsOpen(true)
        setAppName("ttus")
        setCommandName("tt_override_connection")
        setMessage("Are you Sure you want to Disable the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Connection(s) \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
        setParam({
            status: "disable",
            connection_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickConnectionEnable = () => {
        setIsOpen(true)
        setAppName("ttus")
        setCommandName("tt_override_connection")
        setMessage("Are you Sure you want to Enable the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Connections \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
        setParam({
            status: "enable",
            connection_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickConnectionToggle = () => {
        if ((parseSelectedID(agTable.current.api.getSelectedNodes()).length) > 30) {
            addToast("Maximum 30 Connections at a Time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("ttus")
            setCommandName("tt_auto_toggle_connection")
            setMessage("Are you Sure you want to Toggle the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Connections \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
            setParam({
                connection_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
                reason: triageActionReason
            })
        }
    }

    const handleClickFixDisable = () => {
        setIsOpen(true)
        setAppName("ttus")
        setCommandName("tt_override_fix_session")
        setMessage("Are you Sure you want to Disable the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Session(s) \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
        setParam({
            status: "disable",
            fix_session_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickFixEnable = () => {
        setIsOpen(true)
        setAppName("ttus")
        setCommandName("tt_override_fix_session")
        setMessage("Are you Sure you want to Enable the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Session(s) \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
        setParam({
            status: "enable",
            fix_session_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickFixToggle = () => {
        if ((parseSelectedID(agTable.current.api.getSelectedNodes()).length) > 30) {
            addToast("Maximum 30 Sessions at a Time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("ttus")
            setCommandName("tt_auto_toggle_fix_session")
            setMessage("Are you Sure you want to Toggle the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Session(s) \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
            setParam({
                fix_session_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
                reason: triageActionReason
            })
        }
    }

    const handleClickAwsRestoreDefaults = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("restore_route53")
        setMessage("Are you sure you want to restore the following " + parseAppID(agTable.current.api.getSelectedNodes()) + " to default \n")
        setParam({
            app: parseAppID(agTable.current.api.getSelectedNodes()).toString(),
            source_region: parseFromRegion(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickAwsFailoverane1 = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("failover_route53")
        setMessage("Are you sure you want to failover the following " + parseAppID(agTable.current.api.getSelectedNodes()) + " to region ap-northeast-1 \n")
        setParam({
            app: parseAppID(agTable.current.api.getSelectedNodes()).toString(),
            source_region: parseFromRegion(agTable.current.api.getSelectedNodes()).toString(),
            target_region: ("ap-northeast-1"),
            reason: triageActionReason
        })
    }

    const handleClickAwsFailovereuw1 = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("failover_route53")
        setMessage("Are you sure you want to failover the following " + parseAppID(agTable.current.api.getSelectedNodes()) + " to region eu-west-1 \n")
        setParam({
            app: parseAppID(agTable.current.api.getSelectedNodes()).toString(),
            source_region: parseFromRegion(agTable.current.api.getSelectedNodes()).toString(),
            target_region: ("eu-west-1"),
            reason: triageActionReason
        })
    }

    const handleClickAwsFailoveruse1 = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("failover_route53")
        setMessage("Are you sure you want to failover the following " + parseAppID(agTable.current.api.getSelectedNodes()) + " to region us-east-1 \n")
        setParam({
            app: parseAppID(agTable.current.api.getSelectedNodes()).toString(),
            source_region: parseFromRegion(agTable.current.api.getSelectedNodes()).toString(),
            target_region: ("us-east-1"),
            reason: triageActionReason
        })
    }

    const handleClickAwsRestoreTitlebarDefaults = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("restore_titlebar_route53")
        setMessage("Are you sure you want to restore the following Titlebar auth entrypoint(s) " + parseTitlebarRegion(agTable.current.api.getSelectedNodes()) + " to default \n")
        setParam({
            region: parseTitlebarRegion(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleClickAwsFailoverTitlebarEuw1 = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("failover_titlebar_route53")
        setMessage("Are you sure you want to failover the following Titlebar auth entrypoint(s) " + parseTitlebarRegion(agTable.current.api.getSelectedNodes()) + " to region eu-west-1 \n")
        setParam({
            source_region: parseTitlebarRegion(agTable.current.api.getSelectedNodes()).toString(),
            target_region: ("eu-west-1"),
            reason: triageActionReason
        })
    }

    const handleClickAwsFailoverTitlebarUse1 = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("failover_titlebar_route53")
        setMessage("Are you sure you want to failover the following Titlebar auth entrypoint(s) " + parseTitlebarRegion(agTable.current.api.getSelectedNodes()) + " to region us-east-1 \n")
        setParam({
            source_region: parseTitlebarRegion(agTable.current.api.getSelectedNodes()).toString(),
            target_region: ("us-east-1"),
            reason: triageActionReason
        })
    }

    const handleClickJuno = (resetBouncer) => {
        if ((parseSelectedID(agTable.current.api.getSelectedNodes()).length) > 20) {
            addToast("Maximum 20 Accounts at a Time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("juno_up")
            setCommandName("account_reset")
            setMessage("Are you Sure you want to Reset the Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Juno Account(s) Without Bouncer Reset \n" + parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
            if (resetBouncer) {
                setParam({
                    target: dcQuery.data.node[0].datacenter.name,
                    bouncer_reset: true,
                    account_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
                    reason: triageActionReason
                })
            } else {
                setParam({
                    target: nodeName,
                    account_id: parseSelectedID(agTable.current.api.getSelectedNodes()).toString(),
                    reason: triageActionReason
                })
            }
        }
    }

    const handleClickReaper = () => {
        setIsOpen(true)
        setAppName("reaper")
        setCommandName("repair")
        setMessage("Are you Sure you want to Repair The Following " + parseSelectedID(agTable.current.api.getSelectedNodes()).length + " Schedule(s) \n\n" + parseSelectedIDReaper(agTable.current.api.getSelectedNodes()).toString())
        //setScheduleId(parseSelectedID(agTable.current.api.getSelectedNodes()).toString())
    }

    const handleClickEdgeDropUserSession = () => {
        const sessionsIds = parseSelectedUniqueID(agTable.current.api.getSelectedNodes())
        const userIds = parseSelectedUserID(agTable.current.api.getSelectedNodes())
        if (sessionsIds.length < 1) {
            addToast("Please select a session that needs to be dropped", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (sessionsIds.length > 1) {
            addToast("Only 1 Session at a Time can be dropped", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("edgeserver")
            setCommandName("post_user_session_action")
            setMessage("Are you sure you want to DROP the user Session \n" + sessionsIds.toString() + " of User ID " + userIds.toString())
            setParam({
                session_id: sessionsIds.toString(),
                session_action: "drop_user",
                reason: triageActionReason
            })
        }
    }

    const handleClickEdgeMoveUserSession = (serverList) => {
        const sessionsIds = parseSelectedUniqueID(agTable.current.api.getSelectedNodes())
        if (sessionsIds.length < 1) {
            addToast("Please select a session that needs to be moved", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (sessionsIds.length > 1) {
            addToast("Only 1 Session at a Time can be moved", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            const parentMenu = "handleClickEdgeMoveUserSession"
            let subMenuItems = []
            subMenuItems = serverList.reduce((items, node) => {
                items.push({
                    label: node, onClick: () => {
                        handleClickSubMenu(parentMenu, node)
                    }
                })
                return items
            }, [])

            setSubMenuItems(subMenuItems)
            setSubMenu("Select Destination Server")
        }
    }

    const EdgeMoveUserSession = (selectedValue) => {
        const sessionsIds = parseSelectedUniqueID(agTable.current.api.getSelectedNodes())
        const userIds = parseSelectedUserID(agTable.current.api.getSelectedNodes())
        setIsOpen(true)
        setAppName("edgeserver")
        setCommandName("post_move")
        setMessage("Are you sure you want to MOVE the user Session \n" + sessionsIds.toString() + " of User ID " + userIds.toString() + " to server " + selectedValue)
        setParam({
            session_id: sessionsIds.toString(),
            new_host: selectedValue,
            reason: triageActionReason
        })
    }

    const handleClickFixResetSeqNumber = () => {
        const sessionsIds = parseSelectedID(agTable.current.api.getSelectedNodes())
        const sessionType = parseFixType(agTable.current.api.getSelectedNodes())

        const fixMap = {
            "FIX Drop Copy": "fixdropcopy",
            "FIX Inbound Drop Copy": "fixinbounddropcopy",
            "FIX Order Routing": "fixorderrouting",
        }

        const session_type = (sessionType && fixMap[sessionType.toString()]) ? fixMap[sessionType.toString()] : ''

        if (sessionsIds.length < 1) {
            addToast("Please select a session to be reset", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (sessionsIds.length > 1) {
            addToast("Only 1 Session at a Time can be reset", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            if (session_type) {
                setSubMenu("FIXResetMenu")
                onOpen()
            } else {
                addToast("Only FIX Order Routing/FIX Drop Copy/FIX Inbound Drop Copy Supported for seq number reset", {
                    appearance: "error",
                    autoDismiss: true,
                })
            }
        }
    }


    const handleDisableLambda = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_lambda")
        setMessage("Are you sure you want to disable the following Lambdas " + parseSelectedLambdaFunction(agTable.current.api.getSelectedNodes()).toString() + "\n")
        setParam({
            arn: parseSelectedLambdaARN(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleEnableLambda = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_lambda")
        setMessage("Are you sure you want to enable the following Lambdas " + parseSelectedLambdaFunction(agTable.current.api.getSelectedNodes()).toString() + "\n")
        setParam({
            arn: parseSelectedLambdaARN(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason
        })
    }

    const handleDisableLambdaAllApps = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_lambda_by_app")
        setMessage("Are you sure you want to disable all lambdas registered as TT Applications in " + selectedAwsRegion)
        setParam({
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleEnableLambdaAllApps = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_lambda_by_app")
        setMessage("Are you sure you want to enable all lambdas registered as TT Applications in " + selectedAwsRegion)
        setParam({
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleDisableAllLambdas = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_lambda_by_app")
        setMessage("Are you sure you want to disable ALL Lambdas in " + selectedAwsRegion)
        setParam({
            force: true,
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleEnableAllLambdas = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_lambda_by_app")
        setMessage("Are you sure you want to enable ALL Lambdas in " + selectedAwsRegion)
        setParam({
            force: true,
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleDisableS3Bucket = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_s3")
        setMessage("Are you sure you want to disable the following S3 bucket: " + parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString() + "\n")
        setParam({
            bucket: parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason,
            expiration: s3PolicyExpiration * 60
        })
    }

    const handleEnableS3Bucket = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_s3")
        setMessage("Are you sure you want to enable the following S3 bucket: " + parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString() + "\n")
        setParam({
            bucket: parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString(),
            remove_expired_only: false,
            reason: triageActionReason
        })
    }

    const handleResyncS3Bucket = () => {
        setIsOpen(true)
        setAppName("aws")
        setCommandName("resync_s3_buckets")
        setMessage("Are you sure you want to resync bucket replications the following S3 bucket: " + parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString() + "\n")
        setParam({
            bucket: parseSelectedS3Bucket(agTable.current.api.getSelectedNodes()).toString(),
            reason: triageActionReason,
            hours_ago: s3ResyncHours

        })
    }

    const handleDisableS3BucketsAllApps = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_s3_by_app")
        setMessage("Are you sure you want to disable all S3 buckets registered as TT Applications in " + selectedAwsRegion)
        setParam({
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
            expiration: s3PolicyExpiration * 60
        })
    }

    const handleEnableS3BucketsAllApps = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_s3_by_app")
        setMessage("Are you sure you want to enable all S3 buckets registered as TT Applications in " + selectedAwsRegion)
        setParam({
            application: "ALL",
            remove_expired_only: false,
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleDisableAllS3Buckets = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("disable_s3_by_app")
        setMessage("Are you sure you want to disable ALL S3 Buckets in " + selectedAwsRegion)
        setParam({
            force: true,
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
            expiration: s3PolicyExpiration * 60
        })
    }

    const handleEnableAllS3Buckets = () => {
        let selectedAwsRegion = "all"
        let availableAwsRegions = []
        agTable.current.api.forEachNode(node => availableAwsRegions.push(node.data.region));
        availableAwsRegions = [...new Set(availableAwsRegions)]

        if (availableAwsRegions.length === 1) {
            selectedAwsRegion = availableAwsRegions[0]
        }

        setIsOpen(true)
        setAppName("aws")
        setCommandName("enable_s3_by_app")
        setMessage("Are you sure you want to enable ALL Lambdas in " + selectedAwsRegion)
        setParam({
            remove_expired_only: false,
            force: true,
            application: "ALL",
            reason: triageActionReason,
            region: selectedAwsRegion,
        })
    }

    const handleClickGlobalAcceleratorEndpointTrafficDial = (trafficDialPercentage) => {
        const [endpointARNs, endpointDescription] = parseSelectedEndpointGroups(agTable.current.api.getSelectedNodes())
        if (endpointARNs.length < 1) {
            addToast("Please select an Endpoint Group for which Traffic Dial has to be set", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            setIsOpen(true)
            setAppName("aws")
            setCommandName("global_accelerator_traffic_dial")
            setMessage("Are you sure you want to set Traffic Dial of the following Endpoint Groups: " + endpointDescription.toString() + "\n")
            setParam({
                endpoint_groups_arn: endpointARNs.toString(),
                reason: triageActionReason,
                traffic_dial_percentage: trafficDialPercentage
            })
        }
    }

    const handleStopRDSRegionalCluster = () => {
        const rdsClusters = parseSelectedRDSClusters(agTable.current.api.getSelectedNodes())
        if (rdsClusters.length < 1) {
            addToast("Please select an RDS Cluster to be stopped", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (rdsClusters.length > 1) {
            addToast("Only 1 RDS Cluster at a time can be stopped", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            let name = rdsClusters[0][0]
            let region = rdsClusters[0][1]
            let globalClusterName = rdsClusters[0][2]
            if (globalClusterName === null || globalClusterName === "") {
                setIsOpen(true)
                setAppName("aws")
                setCommandName("break_rds_standalone_cluster")
                setMessage("Are you sure you want to stop the following RDS Cluster: " + name + "\n")
                setParam({
                    region: region,
                    cluster_name: name,
                    reason: triageActionReason,
                    wait_for_stopped: true,
                    dry_run: false,
                })
            } else {
                addToast("Only RDS Regional Cluster supported for regional stop command", {
                    appearance: "error",
                    autoDismiss: true,
                })
            }
        }
    }

    const handleStartRDSRegionalCluster = () => {
        const rdsClusters = parseSelectedRDSClusters(agTable.current.api.getSelectedNodes())
        if (rdsClusters.length < 1) {
            addToast("Please select an RDS Cluster to be started", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (rdsClusters.length > 1) {
            addToast("Only 1 RDS Cluster at a time can be started", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            let name = rdsClusters[0][0]
            let region = rdsClusters[0][1]
            let globalClusterName = rdsClusters[0][2]
            if (globalClusterName === null || globalClusterName === "") {
                setIsOpen(true)
                setAppName("aws")
                setCommandName("restore_rds_standalone_cluster")
                setMessage("Are you sure you want to start the following RDS Cluster: " + name + "\n")
                setParam({
                    region: region,
                    cluster_name: name,
                    reason: triageActionReason,
                    wait_for_available: true,
                    dry_run: false,
                })
            } else {
                addToast("Only RDS Regional Cluster supported for regional start command", {
                    appearance: "error",
                    autoDismiss: true,
                })
            }
        }
    }

    const handleBreakRDSGlobalClusterRegion = () => {
        const rdsClusters = parseSelectedRDSClusters(agTable.current.api.getSelectedNodes())
        if (rdsClusters.length < 1) {
            addToast("Please select an RDS Cluster to break", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (rdsClusters.length > 1) {
            addToast("Only 1 RDS Cluster can receive a break command at a time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            let name = rdsClusters[0][0]
            let region = rdsClusters[0][1]
            let globalClusterName = rdsClusters[0][2]
            if (globalClusterName === null || globalClusterName === "") {
                addToast("Only a regional RDS cluster in a global cluster supported for this command", {
                    appearance: "error",
                    autoDismiss: true,
                })
            } else {
                setIsOpen(true)
                setAppName("aws")
                setCommandName("break_rds_global_cluster_region")
                setMessage("Are you sure you want to break the following RDS Cluster: " + name + "\n")
                setParam({
                    region: region,
                    cluster_name: name,
                    reason: triageActionReason,
                    wait_for_applied: true,
                    dry_run: false,
                })
            }
        }
    }

    const handleRestoreRDSGlobalClusterRegion = () => {
        const rdsClusters = parseSelectedRDSClusters(agTable.current.api.getSelectedNodes())
        if (rdsClusters.length < 1) {
            addToast("Please select an RDS Cluster to restore", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (rdsClusters.length > 1) {
            addToast("Only 1 RDS Cluster can receive a restore command at a time", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            let name = rdsClusters[0][0]
            let region = rdsClusters[0][1]
            let globalClusterName = rdsClusters[0][2]
            if (globalClusterName === null || globalClusterName === "") {
                addToast("Only a regional RDS cluster in a global cluster supported for this command", {
                    appearance: "error",
                    autoDismiss: true,
                })
            } else {
                setIsOpen(true)
                setAppName("aws")
                setCommandName("restore_rds_global_cluster_region")
                setMessage("Are you sure you want to restore the following RDS Cluster: " + name + "\n")
                setParam({
                    region: region,
                    cluster_name: name,
                    reason: triageActionReason,
                    wait_for_applied: true,
                    dry_run: false,
                })
            }
        }
    }

    const FixResetMenu = () => {

        const [inbound, setinbound] = useState(0);
        const [outbound, setoutbound] = useState(0);

        return (
            <>
                {show && (
                    <Layer position="right"
                        modal onEsc={onClose} pad="medium"
                        onClickOutside={onClose}>

                        <Box direction="column" gap="small">
                            <FormField label="Inbound Sequence Number">
                                <TextInput
                                    placeholder="Inbound Sequence Number"
                                    value={inbound}
                                    onChange={event => setinbound(event.target.value)}
                                />
                            </FormField>

                            <FormField label="Outbound Sequence Number">
                                <TextInput
                                    placeholder="Outbound Sequence Number"
                                    value={outbound}
                                    onChange={event => setoutbound(event.target.value)}
                                />
                            </FormField>
                            <Button primary color="brand" label="Submit" onClick={() => { FixResetSeqNumber(inbound, outbound) }} />
                        </Box>

                    </Layer>
                )}

            </>
        )
    }

    const FixResetSeqNumber = (inbound, outbound) => {

        const sessionType = parseFixType(agTable.current.api.getSelectedNodes())
        const sessionComp = parseCompId(agTable.current.api.getSelectedNodes())
        const nodeName = parseNodeName(agTable.current.api.getSelectedNodes())

        const fixMap = {
            "FIX Drop Copy": "fixdropcopy",
            "FIX Inbound Drop Copy": "fixinbounddropcopy",
            "FIX Order Routing": "fixorderrouting",
        }
        const session_type = (sessionType && fixMap[sessionType.toString()]) ? fixMap[sessionType.toString()] : ''

        setIsOpen(true)
        setAppName("fix")
        setCommandName("reset_seq_number")
        setMessage("Are you sure you want to reset seq number for compid \n" + sessionComp.toString() + " to inbound:" + inbound.toString() + " outbound:" + outbound.toString())
        setParam({
            target: nodeName && nodeName.toString(),
            session_type: session_type,
            client_comp_id: sessionComp && sessionComp.toString(),
            auto_disable_session_then_enable_after: true,
            reset_inbound_number: inbound,
            reset_outbound_number: outbound,
            reason: triageActionReason
        })
    }

    const handleClickBankAlgoResetSeqNumber = () => {
        const sessionsIds = parseSelectedID(agTable.current.api.getSelectedNodes())
        const market = parseSelectedMarket(agTable.current.api.getSelectedNodes())

        if (sessionsIds.length < 1) {
            addToast("Please select a session to be reset", {
                appearance: "error",
                autoDismiss: true,
            })
        } else if (sessionsIds.length > 1) {
            addToast("Only 1 Session at a Time can be reset", {
                appearance: "error",
                autoDismiss: true,
            })
        } else {
            if (market[0] === 'BANK_ALGO') {
                setSubMenu("BankAlgoResetMenu")
                onOpen()
            } else {
                addToast("Only BANK_ALGO supported for seq number reset", {
                    appearance: "error",
                    autoDismiss: true,
                })
            }
        }
    }

    const BankAlgoResetMenu = () => {

        const [inbound, setinbound] = useState(0);
        const [outbound, setoutbound] = useState(0);

        return (
            <>
                {show && (
                    <Layer position="right"
                        modal onEsc={onClose} pad="medium"
                        onClickOutside={onClose}>

                        <Box direction="column" gap="small">
                            <FormField label="Inbound Sequence Number">
                                <TextInput
                                    placeholder="Inbound Sequence Number"
                                    value={inbound}
                                    onChange={event => setinbound(event.target.value)}
                                />
                            </FormField>

                            <FormField label="Outbound Sequence Number">
                                <TextInput
                                    placeholder="Outbound Sequence Number"
                                    value={outbound}
                                    onChange={event => setoutbound(event.target.value)}
                                />
                            </FormField>
                            <Button primary color="brand" label="Submit" onClick={() => { BankAlgoResetSeqNumber(inbound, outbound) }} />
                        </Box>

                    </Layer>
                )}

            </>
        )
    }

    const BankAlgoResetSeqNumber = (inbound, outbound) => {

        const nodeName = parseNodeName(agTable.current.api.getSelectedNodes())
        const connection_id = parseSelectedID(agTable.current.api.getSelectedNodes())

        setIsOpen(true)
        setAppName("fixgworders")
        setCommandName("reset_seq_number")
        setMessage("Are you sure you want to reset seq number for connection id \n" + connection_id.toString() + " to inbound:" + inbound.toString() + " outbound:" + outbound.toString())
        setParam({
            target: nodeName && nodeName.toString(),
            connection_id: connection_id,
            auto_disable_session_then_enable_after: true,
            reset_inbound_number: inbound,
            reset_outbound_number: outbound,
            reason: triageActionReason
        })
    }


    const handleClickSubMenu = (parentMenu, selectedValue) => {

        setSubMenuItems([])
        setSubMenu("")

        if (parentMenu === "handleClickEdgeMoveUserSession" && selectedValue) {
            EdgeMoveUserSession(selectedValue)
        }
    }

    // Delete smoketest downtime configurations
    const deleteSmoketestDowntimeConfig = async (ids) => {
        let smokeTestURL = "https://smoketest-master.debesys.net/downtime";
        if (envSelected) {
            if (envSelected.startsWith("ext")) {
                smokeTestURL = "https://smoketest-master.trade.tt/downtime";
            }
        } else {
            addToast("Please select an environment", {
                appearance: "error",
                autoDismiss: true,
            });
            return;
        }
        ids.forEach(async (id) => {
            try {
                const response = await axios.delete(`${smokeTestURL}/${id}`);
                if (response.status === 200) {
                    const msg =  `Downtime configuration ${id} deleted successfully. Cache will be updated in a minute.`
                    console.log(msg)
                    addToast(msg, {
                        appearance: "success",
                        autoDismiss: true,
                    });
                }
                else {
                    const msg =  `Error deleting Downtime configuration ${id} ${response.data}`
                    console.log(msg)
                    addToast(msg, {
                        appearance: "error",
                        autoDismiss: true,
                    });
                }
            } catch (error) {
                const msg =  `Error deleting Downtime configuration ${id} ${error.message}`
                console.log(msg)
                addToast(msg, {
                    appearance: "error",
                    autoDismiss: true,
                });
            }
        });
    }

    // Handle delete smoketest downtime configuration
    const handleDeleteSmoketestConfiguration = () => {
        const smoketestConfigurations = parseSelectedSmoketestDowntimeConfig(agTable.current.api.getSelectedNodes());
        if (smoketestConfigurations.length < 1) {
            addToast("Please select a Smoketest Configuration to be deleted", {
                appearance: "error",
                autoDismiss: true,
            })
        }
        else {
            // Delete each selected dowtime configuration
            deleteSmoketestDowntimeConfig(smoketestConfigurations);
        }
    }

    let menuItems = []
    if (tableName === "HealthStatusServiceBouncer3") {
        menuItems = [
            { label: 'Reset Selected Accounts (Max 20)', onClick: () => { handleClickBouncer() } },
        ]
    } else if (tableName === "HealthStatusServiceJuno2") {
        menuItems = [
            { label: 'Reset Selected Accounts (Max 20)', onClick: () => { handleClickJuno(false) } },
            { label: 'Reset Selected Accounts (Max 20) + Bouncer Reset (Max 20)', onClick: () => { handleClickJuno(true) } },
        ]
    } else if (tableName === "ReaperSchedule") {
        menuItems = [
            { label: 'Run Schedule', onClick: () => { handleClickReaper() } },
        ]
    } else if (tableName === "SessionConnections2" || tableName === "HealthStatusServiceConnection5" || tableName === "AggSessionsConnections") {
        menuItems = [
            { label: 'Disable (Max 30)', onClick: () => { handleClickConnectionDisable() } },
            { label: 'Enable (Max 30)', onClick: () => { handleClickConnectionEnable() } },
            { label: 'Toggle (Max 30)', onClick: () => { handleClickConnectionToggle() } },
            { label: 'Bankalgo Reset Seq Number (Max 1)', onClick: () => { handleClickBankAlgoResetSeqNumber() } },
        ]
    } else if (tableName === "SessionFixSessionsv2" || tableName === "HealthStatusServiceFix" || tableName === "AggSessionsFix") {
        menuItems = [
            { label: 'Disable (Max 30)', onClick: () => { handleClickFixDisable() } },
            { label: 'Enable (Max 30)', onClick: () => { handleClickFixEnable() } },
            { label: 'Toggle (Max 30)', onClick: () => { handleClickFixToggle() } },
            { label: 'Reset Seq Number (Max 1)', onClick: () => { handleClickFixResetSeqNumber() } },
            //{ label: 'Bump (Max 1)', onClick: () => { handleClickFixBump() } },
        ]
    } else if (tableName === "HealthStatusServiceEdgev2") {
        if (!edgeServers.loading && edgeServers.data && edgeServers.data.nodeByServiceGroupView && edgeServers.data.nodeByServiceGroupView.length > 0) {
            let serverList = []
            serverList = edgeServers.data.nodeByServiceGroupView.reduce((servers, node) => {
                servers.push(node.nodeName)
                return servers
            }, [])
            serverList.sort()
            menuItems = [
                { label: 'Drop User Session', onClick: () => { handleClickEdgeDropUserSession() } },
                { label: 'Move User Session', onClick: () => { handleClickEdgeMoveUserSession(serverList) } }
            ]
        }
    } else if (tableName === "Route53") {
        menuItems = [
            { label: 'Failover to ap-northeast-1', onClick: () => { handleClickAwsFailoverane1() } },
            { label: 'Failover to eu-west-1', onClick: () => { handleClickAwsFailovereuw1() } },
            { label: 'Failover to us-east-1', onClick: () => { handleClickAwsFailoveruse1() } },
            { label: 'Restore to defaults', onClick: () => { handleClickAwsRestoreDefaults() } },
        ]
    } else if (tableName === "TitlebarRoute53") {
        menuItems = [
            { label: 'Failover to eu-west-1', onClick: () => { handleClickAwsFailoverTitlebarEuw1() } },
            { label: 'Failover to us-east-1', onClick: () => { handleClickAwsFailoverTitlebarUse1() } },
            { label: 'Restore to defaults', onClick: () => { handleClickAwsRestoreTitlebarDefaults() } },
        ]
    } else if (tableName === "AWSLambda") {
        menuItems = [
            { label: 'Disable selected lambda', onClick: () => { handleDisableLambda() } },
            { label: 'Disable all tagged lambdas in selected region', onClick: () => { handleDisableLambdaAllApps() } },
            { label: 'Disable all lambdas in selected region', onClick: () => { handleDisableAllLambdas() } },
            { label: 'Enable selected lambda', onClick: () => { handleEnableLambda() } },
            { label: 'Enable all tagged lambdas in selected region', onClick: () => { handleEnableLambdaAllApps() } },
            { label: 'Enable all lambdas in selected region', onClick: () => { handleEnableAllLambdas() } },
        ]
    } else if (tableName === "AWSS3") {

        if (process.env.REACT_APP_ENVIRONMENT?.startsWith("int-dev") || process.env.REACT_APP_ENVIRONMENT?.startsWith("int-preview") || process.env.REACT_APP_ENVIRONMENT === "local") {
            menuItems = [
                { label: 'Disable selected S3 buckets', onClick: () => { handleDisableS3Bucket() } },
                { label: 'Disable all tagged S3 buckets in selected region', onClick: () => { handleDisableS3BucketsAllApps() } },
                { label: 'Disable all S3 buckets in selected region', onClick: () => { handleDisableAllS3Buckets() } },
                { label: 'Enable selected S3 buckets', onClick: () => { handleEnableS3Bucket() } },
                { label: 'Enable all tagged S3 buckets in selected region', onClick: () => { handleEnableS3BucketsAllApps() } },
                { label: 'Enable all S3 buckets in selected region', onClick: () => { handleEnableAllS3Buckets() } },
                { label: 'Resync S3 bucket replication', onClick: () => { handleResyncS3Bucket() } },
            ]
        } else if (process.env.REACT_APP_ENVIRONMENT?.startsWith("ext-prod") || process.env.REACT_APP_ENVIRONMENT?.startsWith("ext-uat") || process.env.REACT_APP_ENVIRONMENT === "local-prod") {
            menuItems = [
                { label: 'Resync S3 bucket replication', onClick: () => { handleResyncS3Bucket() } },
            ]
        }

    } else if (tableName === "AWSGlobalAccelerator") {

        menuItems = [
            { label: 'Set Traffic dial Percentage to 0', onClick: () => { handleClickGlobalAcceleratorEndpointTrafficDial(0) } },
            { label: 'Set Traffic dial Percentage to 100', onClick: () => { handleClickGlobalAcceleratorEndpointTrafficDial(100) } },
        ]

    } else if (tableName === "AWSRDS") {
        menuItems = [
            { label: 'Stop RDS Regional Cluster', onClick: () => { handleStopRDSRegionalCluster() } },
            { label: 'Start RDS Regional Cluster', onClick: () => { handleStartRDSRegionalCluster() } },
            { label: 'Break RDS Global Cluster Region', onClick: () => { handleBreakRDSGlobalClusterRegion() } },
            { label: 'Restore RDS Global Cluster Region', onClick: () => { handleRestoreRDSGlobalClusterRegion() } },
        ]
    } else if (tableName === "SmoketestDowntimeDetails") {
        menuItems = [
            { label: 'Delete Record', onClick: () => { handleDeleteSmoketestConfiguration() } },
        ]
    }


    return (
        <>
            {!liteMode && menuItems && menuItems.length > 0 &&
                <Box
                    align="center"
                    background={{ color: "brand", opacity: "strong" }}
                    round="small"
                    width="150px"
                    height="40px"
                >
                    <Menu
                        plain
                        size="small"
                        label="Actions"
                        alignSelf="center"
                        align="center"
                        icon={<Services size="small" />}
                        items={menuItems}
                    />

                    {SubMenu && subMenuItems && SubMenu !== 'FIXResetMenu' && SubMenu !== 'BankAlgoResetMenu' && (
                        <Layer position="right" modal >
                            <Menu
                                plain
                                size="small"
                                label={SubMenu}
                                icon={<Services size="small" />}
                                items={subMenuItems}
                            />
                        </Layer>
                    )}
                    {SubMenu && SubMenu === 'FIXResetMenu' &&
                        <FixResetMenu />
                    }
                    {SubMenu && SubMenu === 'BankAlgoResetMenu' &&
                        <BankAlgoResetMenu />
                    }
                </Box>
            }

            {isOpen && !dcQuery.loading && (
                <CommandFormConfirmation
                    appName={appName}
                    commandName={commandName}
                    envSelected={envSelected}
                    setIsOpen={setIsOpen}
                    setConfirmation={setConfirmation}
                    message={message}
                    params={param}
                />
            )}
        </>
    )
}

export const AgDataTableActionsDropDown = ({
    agTable, tableName, enableDetailView, setEnableDetailView, nodeName,
    showDetailedButton = true, triageActionReason = '',
    s3PolicyExpiration = 20, s3ResyncHours = 12

}) => {

    // Handle Set Detailed View
    const handleDetailedView = () => {
        setEnableDetailView(!enableDetailView)
    }

    return (

        <Box direction='row' gap="small" align="center">
            {showDetailedButton &&
                <Box width="220px" height="40px" justify="center"
                    align="center"
                    alignContent="center"
                    alignSelf="center">
                    <Button plain onClick={handleDetailedView} >
                        <CheckBox
                            tabIndex="-1"
                            checked={enableDetailView}
                            label={<Text size="14px" weight="normal">Detailed View</Text>}
                        />
                    </Button>
                </Box>
            }
            <AgDataTableActions
                agTable={agTable}
                tableName={tableName}
                nodeName={nodeName}
                triageActionReason={triageActionReason}
                s3PolicyExpiration={s3PolicyExpiration}
                s3ResyncHours={s3ResyncHours}
            />

        </Box>
    )
}

export default AgDataTableActionsDropDown
